import { Icon } from "semantic-ui-react";

import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import DropdownPortal from "../../ui/components/DropdownPortal/DropdownPortal";
import themeColors from "../../ui/constants/themeColors";

import TableContext from "./TableContext";
import TableHeaderCell from "./TableHeaderCell";

export default function TableColumnSelector({ onChangeVisibleColumns }) {
	const { t } = useTranslation();

	const { columns, visibleColumns, setVisibleColumns, defaultVisibleColumns } = useContext(TableContext);

	const handleChangeColumn = (id) => {
		setVisibleColumns((visibleColumns) => {
			const newVisibleColumns = visibleColumns.includes(id)
				? visibleColumns.filter((column) => column !== id)
				: [...visibleColumns, id];

			if (onChangeVisibleColumns) {
				onChangeVisibleColumns(newVisibleColumns);
			}

			return newVisibleColumns;
		});
	};

	const handleReset = () => {
		setVisibleColumns(defaultVisibleColumns);
		onChangeVisibleColumns?.(defaultVisibleColumns);
	};

	const isFilterActive = columns
		.filter(({ hidden }) => !hidden)
		.some(({ id }) => visibleColumns.includes(id) !== defaultVisibleColumns.includes(id));

	return (
		<TableHeaderCell sticky collapsing>
			<DropdownPortal
				fluid
				icon="columns"
				maxHeight={260}
				options={[
					{
						content: t("reset", "Reset"),
						icon: <Icon flipped="horizontally" name="sync" />,
						onClick: handleReset,
					},
					{
						type: "divider",
					},
					...columns
						.filter(({ hidden }) => !hidden)
						.map(({ id, Header }) => ({
							content: Header,
							icon: visibleColumns.includes(id) ? "check" : " ",
							onClick: () => handleChangeColumn(id),
						})),
				]}
			/>

			{isFilterActive && (
				<div
					style={{
						backgroundColor: themeColors.BLUE,
						width: 10,
						height: 10,
						borderRadius: "50%",
						position: "absolute",
						top: 12,
						right: 8,
						border: "2px solid var(--color-bg-card)",
					}}
				/>
			)}
		</TableHeaderCell>
	);
}
